var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700","rel":"stylesheet"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }